export default "/images/Device_chamadas.png?71658f07efe7dbd69ec44de84c0a7a94";